var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "creadit-card 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 16.1704H1.75V21.4204C1.75 22.1166 2.02656 22.7843 2.51884 23.2766C3.01113 23.7688 3.67881 24.0454 4.375 24.0454H20.125C20.8212 24.0454 21.4889 23.7688 21.9812 23.2766C22.4734 22.7843 22.75 22.1166 22.75 21.4204V16.1704H3.5ZM6.125 18.7954H8.75C8.98206 18.7954 9.20462 18.8876 9.36872 19.0517C9.53281 19.2158 9.625 19.4383 9.625 19.6704C9.625 19.9025 9.53281 20.125 9.36872 20.2891C9.20462 20.4532 8.98206 20.5454 8.75 20.5454H6.125C5.89294 20.5454 5.67038 20.4532 5.50628 20.2891C5.34219 20.125 5.25 19.9025 5.25 19.6704C5.25 19.4383 5.34219 19.2158 5.50628 19.0517C5.67038 18.8876 5.89294 18.7954 6.125 18.7954ZM22.75 12.6704V14.4204H1.75V12.6704C1.75 11.9742 2.02656 11.3065 2.51884 10.8143C3.01113 10.322 3.67881 10.0454 4.375 10.0454H20.125C20.8212 10.0454 21.4889 10.322 21.9812 10.8143C22.4734 11.3065 22.75 11.9742 22.75 12.6704ZM26.25 7.42041V16.1704C26.2485 16.712 26.0795 17.2398 25.7662 17.6816C25.4529 18.1233 25.0106 18.4574 24.5 18.6379V12.6704C24.5 11.5101 24.0391 10.3973 23.2186 9.57682C22.3981 8.75635 21.2853 8.29541 20.125 8.29541H5.25V7.42041C5.25 6.72422 5.52656 6.05654 6.01884 5.56425C6.51113 5.07197 7.17881 4.79541 7.875 4.79541H23.625C24.3212 4.79541 24.9889 5.07197 25.4812 5.56425C25.9734 6.05654 26.25 6.72422 26.25 7.42041Z",
    fill: "#067647"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.80661f701aa958ff758b27d67860ce37.svg";
export { ForwardRef as ReactComponent };